"use strict";

exports.__esModule = true;
exports.applyThemeVariables = void 0;
var _wixSiteThemeVariables = require("@wix/wix-site-theme-variables");
var _cssPropertyParser = require("@wix/css-property-parser");
const CSS_VARIABLE_REGEX = /var\((?:[^()]+|\((?:[^()]+|\([^()]*\))*\))*\)/g;
const applyThemeVariables = (cssValue, themeVariables) => {
  const extractVariableName = value => {
    return value.replace(/--([a-zA-Z0-9_-]+)/, '$1');
  };
  const getThemeToken = variableName => {
    return themeVariables[variableName] && variableName in _wixSiteThemeVariables.WixThemeVariableNames ? themeVariables[variableName] : undefined;
  };
  return cssValue.replace(CSS_VARIABLE_REGEX, match => {
    const cssVariable = _cssPropertyParser.CssVariable.parse(match);
    if (cssVariable) {
      const variableName = extractVariableName(cssVariable.CSSvariable);
      const themeToken = getThemeToken(variableName);
      return themeToken ? themeToken : match;
    }
    return match;
  });
};
exports.applyThemeVariables = applyThemeVariables;
//# sourceMappingURL=apply-theme-variables.js.map